import { lazy } from 'react';

export { Stepper } from './components/Stepper';
export { PostCheckoutProgressBar, SurveyProgressBar } from './components';
export { useIsOnboardingReworkEnabled } from './hooks/useIsOnboardingReworkEnabled';
export * as LanguagePreferences from './pages/LanguagePreferences';
export * as Proficiency from './pages/Proficiency';
export * as Languages from './pages/LanguagesYouSpeak';
export { default as PostCheckoutRoot } from './pages/PostCheckout';
export const TimeSlots = lazy(() => import('./pages/TimeSlots'));
export const BookClass = lazy(() => import('./pages/BookClass'));
export const CreditsTypeSelection = lazy(() => import('./pages/CreditsTypeSelection'));
export const Congratulations = lazy(() => import('./pages/Congratulations'));
export const Welcome = lazy(() => import('./pages/Welcome'));
export const OnboardingSurvey = lazy(() => import('./pages/OnboardingSurvey'));
export * from './constants';
export const LearningGoals = lazy(() => import('./pages/LearningGoals'));
export const LearningGoalsSuccess = lazy(() => import('./pages/LearningGoalsSuccess'));
export const LearningFocusArea = lazy(() => import('./pages/LearningFocusArea'));
export const LearningFocusAreaSuccess = lazy(() => import('./pages/LearningFocusAreaSuccess'));
